import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ArchitectsOfYourFinancialFuture from "./sections/ArchitectsOfYourFinancialFuture";
import ExteriorMastery from "./sections/ExteriorMastery";
import ThePatchDoctorsPromise from "./sections/ThePatchDoctorsPromise";
import OurBuiltLegacy from "./sections/OurBuiltLegacy";
import PropertyCarePartnershipProcess from "./sections/PropertyCarePartnershipProcess";
import Services from "./sections/Services";
import ExecutiveClientPraise from "./sections/ExecutiveClientPraise";
import InitiateYourDominance from "./sections/InitiateYourDominance";
import GoogleReviews from "./sections/GoogleReviews";
import GoogleReview from "./sections/GoogleReview";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ArchitectsOfYourFinancialFuture />
      <ExteriorMastery />
      <ThePatchDoctorsPromise />
      <OurBuiltLegacy />
      <PropertyCarePartnershipProcess />
      <Services />
      <ExecutiveClientPraise />
      <GoogleReviews />
      <GoogleReview />
      <InitiateYourDominance />
      <Footer />
    </div>;
}